import React from "react";
import MaterialContainer from "./MaterialComponent/MaterialContainer";
import { Visibility } from "semantic-ui-react";

const MaterialsIntro = () => (
  <div
    className="section is-medium has-text-light"
    style={{ background: "rgb(54, 54,54)" }}
  >
    <div className="container">
      <div className="columns">
        <div className="column is-5-desktop is-12-touch">
          <h1 className="title is-3 has-text-light">Materials</h1>
        </div>
      </div>
    </div>
  </div>
);

const Materials = props => (
  <div>
    <Visibility {...props} once={false}>
      <MaterialsIntro />
    </Visibility>
    <MaterialContainer />
  </div>
);

export default Materials;



// WEBPACK FOOTER //
// ./src/pages/Materials/Materials.js